import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=96fafb20&scoped=true&"
import script from "./BlogItem.vue?vue&type=script&lang=js&"
export * from "./BlogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fafb20",
  null
  
)

export default component.exports